import { Stack, Heading, Divider } from 'braid-design-system';
import React from 'react';

import ListItem from '../ListItem/ListItem';

import AddIndustries from './AddIndustries';
import { usePreferencesIndustryField } from './usePreferencesIndustryField';

interface Props {
  industries: any[];
  refetch: () => void;
}

const Industries = ({ industries }: Props) => {
  const preferencesIndustryField = usePreferencesIndustryField(industries);

  return (
    <Stack space="large">
      <Heading level="4">Industries</Heading>
      <Stack space="medium">
        {preferencesIndustryField.selected.map((industry) => (
          <ListItem
            key={industry}
            itemLabel={industry}
            remove={() => {
              preferencesIndustryField.onRemoveSingleIndustry(industry);
            }}
          />
        ))}
      </Stack>
      <AddIndustries
        industryGroupings={preferencesIndustryField.value}
        setIndustryGroupings={preferencesIndustryField.onChange}
      />
      <Divider />
    </Stack>
  );
};

export default Industries;
